import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import CustomToggleList from "../RemoteTable/custom-toggle-list";

const SearchTable = props => {
  const {
    onSearchAllHandle,
    children,
    columnToggleProps,
    optionShowColumnHandel,
    listMultipleRowAction,
    rowSelected,
    loading,
    isShowSearchIndex,
    sticky,
  } = props;

  const inputSearch = useRef(null);
  const { t, i18n } = useTranslation("common");
  // Custom Toggle column modal
  const [modalToggleColumn, setModalToggleColumn] = useState(false);
  const toggleCustomModal = () => setModalToggleColumn(!modalToggleColumn);

  // Button tác vụ hàng loạt
  const [isOpenActions, setIsOpenActions] = useState(false);
  const toggleOpenActions = () => setIsOpenActions(!isOpenActions);

  // Delay when search all
  const [searchTerm, setSearchTerm] = useState(null);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm) {
        onSearchAllHandle(searchTerm.target.value.trim());
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  return (
    <div
      className={
        "d-flex flex-column flex-xl-row" + (sticky ? " search-sticky" : "")
      }
    >
      <div className="d-flex d-md-inline-block mb-2 me-sm-2">
        {isShowSearchIndex && (
          <>
            <div className="search-box mb-md-2 me-2 d-inline-block flex-grow-1">
              <div className="position-relative">
                <input
                  ref={inputSearch}
                  type="search"
                  onChange={e => setSearchTerm(e)}
                  className="form-control"
                  placeholder="Tìm kiếm"
                />
                <i
                  className="bx bx-search-alt search-icon"
                  style={{ color: "#50a5f1" }}
                />
              </div>
            </div>
            <Button
              onClick={() => {
                onSearchAllHandle(inputSearch.current?.value?.trim() ?? "");
              }}
              disabled={loading}
              className="primary-btn flex-shrink-0"
              style={{ width: "95px" }}
            >
              {t("search")}
            </Button>
          </>
        )}

        {/* Button tác vụ hàng loạt*/}
        {listMultipleRowAction?.length > 0 && (
          <ButtonDropdown
            className="ms-2"
            isOpen={isOpenActions}
            toggle={toggleOpenActions}
            disabled={loading}
          >
            <DropdownToggle className="btn-label" caret color="success" outline>
              <i className="bx bx-receipt label-icon" />
              <span>{t("actionMultipleRows")}</span>
              <i
                style={{ marginLeft: "5px" }}
                className="mdi mdi-chevron-down"
              />
            </DropdownToggle>
            <DropdownMenu style={{ zIndex: 3, border: " 1px solid #808080d4" }}>
              {listMultipleRowAction.map((action, index) => {
                return (
                  <DropdownItem
                    href="#"
                    key={index}
                    style={{ position: "relative" }}
                    className="d-flex gap-1 align-items-center"
                    onClick={() => {
                      action.onClick && action.onClick(rowSelected);
                    }}
                  >
                    {action.icon}
                    {action.text}
                    {/* {listMultipleRowAction.length !== index + 1 && (
                      <div
                        style={{
                          borderBottom: "1px solid #808080ad",
                          position: "absolute",
                          width: "90%",
                          bottom: 0,
                          left: 0,
                          marginLeft: "auto",
                          marginRight: "auto",
                          right: 0,
                        }}
                      ></div>
                    )} */}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </ButtonDropdown>
        )}
      </div>
      <div className="col ps-0">{children}</div>
      {modalToggleColumn && (
        <div className="col-auto">
          {/* Button ẩn/hiện cột */}
          <ButtonDropdown
            isOpen={modalToggleColumn}
            toggle={() => {
              toggleCustomModal();
            }}
            disabled={loading}
            className="btn-group"
          >
            {/* <DropdownToggle
            title={t("showFilterColumn")}
            // className="btn btn-primary  dropdown-toggle"
            // tag="div"
            caret
            color="warning"
            outline
          >
            <i className="fas fa-filter" />
          </DropdownToggle> */}
            <DropdownMenu
              style={{ zIndex: 4, maxHeight: "60vh", overflow: "auto" }}
              className="dropdown-menu-end"
            >
              <CustomToggleList
                {...columnToggleProps}
                optionShowColumnHandel={optionShowColumnHandel}
              ></CustomToggleList>
            </DropdownMenu>
          </ButtonDropdown>
        </div>
      )}
    </div>
  );
};

SearchTable.propTypes = {
  onSearchAllHandle: PropTypes.func,
  children: PropTypes.any,
  columnToggleProps: PropTypes.any,
  optionShowColumnHandel: PropTypes.func,
  listMultipleRowAction: PropTypes.array,
  rowSelected: PropTypes.array,
  loading: PropTypes.bool,
  isShowSearchIndex: PropTypes.bool,
  sticky: PropTypes.bool,
};

export default SearchTable;
